import AcquisitionsAPI from "@/api/acquisitions";
import { SelectBox } from "@monolith-forensics/monolith-ui";
import { useQuery } from "@tanstack/react-query";
import { FC } from "react";

interface HashTypeSelectorProps {
  defaultValue?: string;
  onChange?: (value: string) => void;
  error?: string;
  openOnFocus?: boolean;
}

type HashType = {
  hash_type: string;
  hash_type_id: number;
};

const HashTypeSelector: FC<HashTypeSelectorProps> = ({
  defaultValue,
  onChange,
  error,
  openOnFocus = false,
}) => {
  const { data: hashTypeList } = useQuery<HashType[]>({
    queryKey: ["acquisition:hash_types:list"],
    queryFn: () => AcquisitionsAPI.getHashTypes(),
  });

  const options =
    hashTypeList?.map((hashType) => ({
      label: hashType?.hash_type,
      value: hashType?.hash_type,
    })) || [];

  return (
    <>
      <SelectBox
        defaultValue={defaultValue}
        size="sm"
        variant="outlined"
        label="Algorithm"
        placeholder="Select..."
        description="This is the hash type that was used for the acquisition."
        onChange={onChange}
        data={options}
        error={error}
        clearable={true}
        searchable={true}
        allowCustomValue={true}
        openOnFocus={openOnFocus}
      />
    </>
  );
};

export default HashTypeSelector;
